"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./Panel"), exports);
tslib_1.__exportStar(require("./Panel.Props"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Panel/index.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Panel/index.js
// module chunks = 1